import { Box } from '@pocketlaw/tetris';
import { ApprovalCheckError } from './ApprovalCheckError';
import { useApprovalCheck } from './ApprovalCheckProvider';
import { EvaluatingState } from './EvaluatingState';
import { InitialState } from './InitialState';
import { ReviewState } from './ReviewState';
export function RequestVoluntaryAdvanced() {
    const { startCheck, state } = useApprovalCheck();
    const handleSelectPrompt = (promptId) => {
        startCheck(promptId);
    };
    if (state === 'done') {
        return <ReviewState />;
    }
    return (<Box flexDirection="column" p="xl" height="100%">
      <ApprovalCheckError />

      {state === 'initial' && <InitialState onSelectPrompt={handleSelectPrompt}/>}

      {state === 'evaluating' && <EvaluatingState />}
    </Box>);
}
